function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 2C9.925 2 5 6.925 5 13c0 2.818 1.058 5.386 2.8 7.333a1 1 0 11-1.49 1.334A12.955 12.955 0 013 13C3 5.82 8.82 0 16 0s13 5.82 13 13c0 3.329-1.253 6.368-3.31 8.667a1 1 0 01-1.49-1.334A10.956 10.956 0 0027 13c0-6.075-4.925-11-11-11z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.504 13a6.496 6.496 0 1111.992 3.466 1 1 0 101.69 1.068 8.496 8.496 0 10-14.372 0 1 1 0 101.69-1.068 6.462 6.462 0 01-1-3.466z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 9a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.658 21a1.5 1.5 0 00-1.493 1.65l.7 7A1.5 1.5 0 0015.357 31h2.285a1.5 1.5 0 001.493-1.35l.7-7A1.5 1.5 0 0018.343 21h-3.685z",
  fill: "currentColor"
})));